import type {
  PostDocumentCommentsRequestType,
  PostDocumentCommentsResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postDocumentsComments = async ({
  documentId,
  ...body
}: PostDocumentCommentsRequestType) => {
  const url = `/api/v2/documents/${documentId}/comments`;
  const response = await apiAuthClient.post<PostDocumentCommentsResponseType>(
    url,
    body,
  );

  return response.data;
};
